import Service from "../Service";

const resource = "fixedassets/";

export default {
    save(obj, requestID) {
        return Service.post(resource + "save", obj, {
            params: { requestID: requestID },
        });
    },
    pagination(parameters, requestID) {
        return Service.post(resource + "pagination", parameters, {
            params: { requestID: requestID },
        });
    },

    getDataQR(obj, requestID) {
        return Service.post(resource + "getDataQR", obj, {
            params: { requestID: requestID },
        });
    }
};